<template>
  <div class="">
    <Header :widthmun="windowWidth" />

    <div class="new_box">
      <div class="container sp">
        <el-row>
          <el-col :span="24">
            <div class="col_list">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">{{
                  $t("home.home")
                }}</el-breadcrumb-item>
                <el-breadcrumb-item>{{
                  $t("opname.title")
                }}</el-breadcrumb-item>
                <el-breadcrumb-item>{{ mename }}</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
            <h2 class="showtitle" v-html="mename"></h2>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="content">
      <div class="container newcont">
        <el-row>
          <el-col>
            <div class="cont_box">
              <el-row>
                <el-col
                  style="background: #fff"
                  v-if="windowWidth >= 1024"
                  class="el-col-box"
                  :xs="24"
                  :sm="24"
                  :md="8"
                  :lg="7"
                  :xl="7"
                >
                  <el-collapse v-model="activeName" accordion>
                    <el-collapse-item :class="activeName == '1' ? 'activeheader' : ''"  :title="$t('opname.title1')"  name="1" >
                      <div>
                        <el-link :underline="false" :class="activeclass == '1' ? 'active' : ''" @click="changemenu($t('opname.mename1'), '1')">{{ $t("opname.mename1") }}</el-link
                        >
                      </div>
                    </el-collapse-item>
                    <el-collapse-item :class="activeName == '3' ? 'activeheader' : ''" :title="$t('opname.title3')" name="3">
                      <div>
                        <el-link :underline="false" :class="activeclass == '7' ? 'active' : ''" @click="changemenu($t('opname.mename7'), '7')">{{ $t("opname.mename7") }}</el-link>
                        <!-- <el-link :underline="false" :class="activeclass == '8' ? 'active' : ''" @click="changemenu($t('opname.mename8'), '8')">{{ $t("opname.mename8") }}</el-link> -->
                      </div>
                    </el-collapse-item>
                  
                    <el-collapse-item :class="activeName == '4' ? 'activeheader' : ''"  :title="$t('opname.title4')"  name="4" >
                      <div>
                        <el-link :underline="false" :class="activeclass == '9' ? 'active' : ''" @click="changemenu($t('opname.mename9'), '9')">{{ $t("opname.mename9") }}</el-link
                        >
                        <el-link :underline="false" :class="activeclass == '8' ? 'active' : ''" @click="changemenu($t('opname.mename8'), '8')">{{ $t("opname.mename8") }}</el-link>
                      </div>
                    </el-collapse-item>
                    <el-collapse-item :class="activeName == '5' ? 'activeheader' : ''"  :title="$t('opname.title5')"  name="5" >
                      <div>
                        <el-link :underline="false" :class="activeclass == '6' ? 'active' : ''" @click="changemenu($t('opname.mename6'), '6')" >{{ $t("opname.mename6") }}</el-link>
                      
                      </div>
                    </el-collapse-item>
                    <el-collapse-item :class="activeName == '2' ? 'activeheader' : ''" :title="$t('opname.title2')" name="2">
                      <div>
                        <el-link :underline="false" :class="activeclass == '2' ? 'active' : ''" @click="changemenu($t('opname.mename2'), '2')">{{ $t("opname.mename2") }}</el-link>
                        <el-link :underline="false" :class="activeclass == '3' ? 'active' : ''" @click="changemenu($t('opname.mename3'), '3')">{{ $t("opname.mename3") }}</el-link>
                        <el-link :underline="false" :class="activeclass == '4' ? 'active' : ''" @click="changemenu($t('opname.mename4'), '4')">{{ $t("opname.mename4") }}</el-link>
                        <el-link :underline="false" :class="activeclass == '5' ? 'active' : ''" @click="changemenu($t('opname.mename5'), '5')">{{ $t("opname.mename5") }}</el-link>
                        
                      </div>
                    </el-collapse-item>
                   </el-collapse>
                </el-col>

                <el-col style="background: #fff" class="cont_box_col" v-show="parmaid == '1'" :xs="24" :sm="24" :md="15" :lg="16" :xl="16">
                  <div>
                    <h3>{{ $t("opname.m1.c1") }}</h3>
                    <p>{{ $t("opname.m1.c2") }}</p>
                    <p>{{ $t("opname.m1.c3") }}</p>
                    <p>{{ $t("opname.m1.c4") }}</p>
                    <p>{{ $t("opname.m1.c5") }}</p>
                    <p>{{ $t("opname.m1.c6") }}</p>
                    <p>{{ $t("opname.m1.c7") }}</p>
                    <p>{{ $t("opname.m1.c8") }}</p>
                  </div>
                </el-col>

                <el-col
                  style="background: #fff"
                  class="cont_box_col"
                  v-show="parmaid == '2'"
                  :xs="24"
                  :sm="24"
                  :md="15"
                  :lg="16"
                  :xl="16"
                >
                  <div>
                    <h3>{{ $t("opname.m2.c1") }}</h3>
                    <p>{{ $t("opname.m2.c2") }}</p>
                    <p>{{ $t("opname.m2.c3") }}</p>
                    <img :src="$t('opname.m2.c4')" alt="" />
                  </div>
                </el-col>

                <el-col
                  style="background: #fff"
                  class="cont_box_col"
                  v-show="parmaid == '3'"
                  :xs="24"
                  :sm="24"
                  :md="15"
                  :lg="16"
                  :xl="16"
                >
                  <div>
                    <h3>{{ $t("opname.m3.c1") }}</h3>
                    <p>
                      <span class="span_box">{{ $t("opname.m3.c2") }}</span
                      >{{ $t("opname.m3.c3") }}
                    </p>
                    <p>{{ $t("opname.m3.c4") }}</p>
                    <img :src="$t('opname.m3.c5')" alt="" />
                  </div>
                </el-col>

                <el-col
                  style="background: #fff"
                  class="cont_box_col"
                  v-show="parmaid == '4'"
                  :xs="24"
                  :sm="24"
                  :md="15"
                  :lg="16"
                  :xl="16"
                >
                  <div>
                    <h3>{{ $t("opname.m4.c1") }}</h3>
                    <p>{{ $t("opname.m4.c2") }}</p>
                    <p>{{ $t("opname.m4.c3") }}</p>
                    <img :src="$t('opname.m4.c4')" alt="" />
                  </div>
                </el-col>

                <el-col
                  style="background: #fff"
                  class="cont_box_col"
                  v-show="parmaid == '5'"
                  :xs="24"
                  :sm="24"
                  :md="15"
                  :lg="16"
                  :xl="16"
                >
                  <div>
                    <h3>{{ $t("opname.m5.c1") }}</h3>
                    <p>{{ $t("opname.m5.c2") }}</p>
                    <p>{{ $t("opname.m5.c3") }}</p>
                    <img :src="$t('opname.m5.c4')" alt="" />
                  </div>
                </el-col>

                <el-col
                  style="background: #fff"
                  class="cont_box_col"
                  v-show="parmaid == '6'"
                  :xs="24"
                  :sm="24"
                  :md="15"
                  :lg="16"
                  :xl="16"
                >
                  <div>
                    <h3>{{ $t("opname.m6.c1") }}</h3>
                    <p>{{ $t("opname.m6.c2") }}</p>
                    <p>{{ $t("opname.m6.c3") }}</p>
                    <img :src="$t('opname.m6.c4')" alt="" />
                  </div>
                </el-col>

                <el-col
                  style="background: #fff"
                  class="cont_box_col"
                  v-show="parmaid == '7'"
                  :xs="24"
                  :sm="24"
                  :md="15"
                  :lg="16"
                  :xl="16"
                >
                  <div>
                    <h3>{{ $t("opname.m7.c1") }}</h3>
                    <p>{{ $t("opname.m7.c2") }}</p>
                    <el-row class="icon_box">
                      <el-col :span="2">
                        <img
                          src="../../assets/img/conit.png"
                          style="padding-right: 20px"
                          alt=""
                        />
                      </el-col>
                      <el-col :span="20" style="text-align: left">
                        <p class="h5">{{ $t("opname.m7.c3") }}</p>
                      </el-col>
                    </el-row>

                    <p class="h4">{{ $t("opname.m7.c4") }}</p>
                    <p>{{ $t("opname.m7.c5") }}</p>
                    <p class="h4">{{ $t("opname.m7.c6") }}</p>
                    <p>{{ $t("opname.m7.c7") }}</p>
                    <p class="h4">{{ $t("opname.m7.c8") }}</p>
                    <p>{{ $t("opname.m7.c9") }}</p>

                    <el-row class="icon_box">
                      <el-col :span="2">
                        <img
                          src="../../assets/img/conit.png"
                          style="padding-right: 20px"
                          alt=""
                        />
                      </el-col>
                      <el-col :span="20" style="text-align: left">
                        <p class="h5">{{ $t("opname.m7.c10") }}</p>
                      </el-col>
                    </el-row>
                    <p class="h4">{{ $t("opname.m7.c11") }}</p>
                    <p class="li_box"><i></i>{{ $t("opname.m7.c12") }}</p>
                    <p class="h4">{{ $t("opname.m7.c13") }}</p>
                    <p class="li_box"><i></i>{{ $t("opname.m7.c14") }}</p>
                    <p class="h4">{{ $t("opname.m7.c15") }}</p>
                    <p class="li_box"><i></i>{{ $t("opname.m7.c16") }}</p>
                    <img :src="$t('opname.m7.c17')" alt="" />
                  </div>
                </el-col>

                <el-col
                  style="background: #fff"
                  class="cont_box_col"
                  v-show="parmaid == '8'"
                  :xs="24"
                  :sm="24"
                  :md="15"
                  :lg="16"
                  :xl="16"
                >
                  <div v-show="cntListShow">
                    <h3>{{ $t("opname.m8.c1") }}</h3>
                    <el-table :data="cntList" empty-text=" " style="width: 100%" class="table">
                      <el-table-column
                        prop="ccerId"
                        :label="$t('opname.m8.c2')"
                        width="200"
                      >
                      </el-table-column>
                      <el-table-column :label="$t('opname.m8.c3')">
                        <template slot-scope="scope">
                          <div
                            style="
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                              word-break: break-all;
                            "
                          >
                            {{ scope.row.ccerName }}
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column :label="$t('opname.m8.c5')" width="100">
                        <template slot-scope="scope">
                          <el-button
                            type="text"
                            size="mini"
                            @click="selectCntItem(scope.row)"
                            >Click</el-button
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div v-show="cntDetailShow">
                    <h3>{{ this.cntItem.ccerName }}</h3>
    


                    <el-form ref="form" label-width="150px">
                      <el-form-item :label="$t('opname.m8.c9')" style="backgroud:">
                        <div>
                          {{ this.cntItem.ccerId }}
                        </div>
                      </el-form-item>
                      <el-form-item :label="$t('opname.m8.c10')">
                        <div>
                          {{ this.cntItem.ccerName }}
                        </div>
                      </el-form-item>
                      <el-form-item :label="$t('opname.m8.c11')">
                        <div>
                          {{ this.cntItem.description }}
                        </div>
                      </el-form-item>
                      <el-form-item :label="$t('opname.m8.c12')">
                        <div>
                          Hash - {{ this.cntItem.hash }}

                          
                        </div>
                        <el-button
                            type="text"
                            size="mini"
                            v-if="token"
                            @click="openUrl('reportURI')"
                            >View Certificate</el-button
                          >
                        <el-button
                            type="text"
                            size="mini"
                            v-if="!token"
                            @click="openUrl('reportURI')"
                            >Certificate is only available to MVGX members. Please login to view.</el-button>
                      </el-form-item>

                      <el-form-item :label="$t('opname.m8.c13')">
                        <div>
                          <el-button
                            type="text"
                            size="mini"
                            @click="openUrl('ccerContractAddressUrl')"
                            >{{ this.cntItem.ccerContractAddress }}</el-button
                          >
                        </div>
                      </el-form-item>

                      <el-form-item :label="$t('opname.m8.c14')">
                        <div>
                          <div>
                            <el-button
                              type="text"
                              size="mini"
                              @click="openUrl('receiver721Url')"
                            >
                              {{ cntItem.receiver721 }}</el-button
                            >
                          </div>
                        </div>
                      </el-form-item>

                      <el-form-item :label="$t('opname.m8.c15')">
                        <div>
                          <div>
                            <el-button
                              type="text"
                              size="mini"
                              @click="openUrl('transactionHash721Url')"
                              >{{ cntItem.transactionHash721 }}</el-button
                            >
                          </div>
                        </div>
                      </el-form-item>
                      <el-form-item> </el-form-item>
                      <el-form-item> </el-form-item>
                      <el-form-item :label="$t('opname.m8.c16')">
                        <div>
                          {{ cntItem.co2 }}
                        </div>
                      </el-form-item>
                      <el-form-item :label="$t('opname.m8.c13')">
                        <div>
                          <el-button
                            type="text"
                            size="mini"
                            @click="openUrl('cntContractAddressUrl')"
                            >{{ this.cntItem.cntContractAddress }}</el-button
                          >
                        </div>
                      </el-form-item>
                      <el-form-item  :label="$t('opname.m8.c17')">
                        <div>
                          <el-button
                            type="text"
                            size="mini"
                            @click="openUrl('receiver20Url')"
                          >
                            {{ cntItem.receiver721 }}</el-button
                          >
                        </div>
                      </el-form-item>

                      <el-form-item  :label="$t('opname.m8.c18')">
                        <div>
                          <el-button
                            type="text"
                            size="mini"
                            @click="openUrl('transactionHash20Url')"
                          >
                            {{ cntItem.transactionHash20 }}</el-button
                          >
                        </div>
                      </el-form-item>
                      <el-form-item> </el-form-item>
                      <el-form-item> </el-form-item>
                    </el-form>

                    <p class="h5">Additional Reports</p>
                    <el-table :data="cntReportList" empty-text=" " style="width: 100%" class="table">
                      <el-table-column
                        prop="ccerId"
                        :label="$t('opname.m8.c6')"
                        width="200"
                      >
                        <template slot-scope="scope">
                          {{ formatDate(scope.row.createTime) }}
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('opname.m8.c7')">
                        <template slot-scope="scope">
                          <div
                            style="
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                              word-break: break-all;
                            "
                          >
                            <div>{{ scope.row.title }}</div>
                            <div>Hash: {{ scope.row.transactionHash }}</div>
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column width="110">
                        <template slot-scope="scope">
                          <el-button
                            type="text"
                            size="mini"
                            @click="openReportUrl(scope.row.reportURI)"
                            >View Document</el-button
                          >
                        </template>
                      </el-table-column>
                    </el-table>

                    <div class="cmd-line">
                      <el-button @click="backCntList">{{
                        $t("opname.m8.c8")
                      }}</el-button>
                    </div>
                  </div>
                </el-col>

                <el-col style="background: #fff" class="cont_box_col" v-show="parmaid == '9'" :xs="24" :sm="24" :md="15" :lg="16" :xl="16">
                  <div>
                    <h3>{{ $t("opname.m9.c1") }}</h3>
                    <p>{{ $t("opname.m9.c2") }}</p>
                    <p>{{ $t("opname.m9.c3") }}</p>
                    <p class="li_box"><i></i>{{ $t("opname.m9.c4") }}</p>
                    <p class="li_box"><i></i>{{ $t("opname.m9.c5") }}</p>
                    <p class="li_box"><i></i>{{ $t("opname.m9.c6") }}</p>
                    <p class="li_box"><i></i>{{ $t("opname.m9.c7") }}</p>
                    <p class="li_box"><i></i>{{ $t("opname.m9.c8") }}</p>
                    
                    <p class="li_box"><i></i>{{ $t("opname.m9.c9") }}</p>
                    <p class="li_box"><i></i>{{ $t("opname.m9.c10") }}</p>
                    <p class="li_box"><i></i>{{ $t("opname.m9.c11") }}</p>
                    <p><span class="h4">{{ $t("opname.m9.c12") }}</span>{{ $t("opname.m9.c13") }}</p>
                    <p class="li_box"><i></i>{{ $t("opname.m9.c14") }}</p>
                    <p class="li_box"><i></i>{{ $t("opname.m9.c15") }}</p>
                    <p class="li_box"><i></i>{{ $t("opname.m9.c16") }}</p>
                    <p class="li_box"><i></i>{{ $t("opname.m9.c17") }}</p>
                    <p class="li_box"><i></i>{{ $t("opname.m9.c18") }}</p>
                    <p class="li_box"><i></i>{{ $t("opname.m9.c19") }}</p>
                    <p class="li_box"><i></i>{{ $t("opname.m9.c20") }}</p>
                  </div>
                </el-col>

                
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <Footer :widthmun="windowWidth" />
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import Header from "@/components/Header/index.vue";
import Footer from "@/components/Footer/index.vue";
import { mapState, mapActions } from "vuex";
import { getDefaultStartTime, formatDate } from "@/util/date";
import authority from '@/api/authority'

export default {
  // import引入的组件需要注入到对象中才能使用
  components: { Header, Footer },
  data() {
    // 这里存放数据
    return {
      parmaid: "",
      token:'',
      activeName: "1",
      mename: "",
      activeclass: "",
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      cntItem: {},
      cntListShow: true,
      cntDetailShow: false,
    };
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapState({
      cntList: (state) => state.cnt.cntList,
      cntReportList: (state) => state.cnt.cntReportList,
    }),
  },
  // 监控data中的数据变化
  watch: {
    windowHeight(val) {
      let that = this;
    },
    windowWidth(val) {
      let that = this;
      this.windowWidth = val;
    },
  },
  // 方法集合
  methods: {
    ...mapActions("cnt", ["getCntList", "getReportList"]),
    changemenu(name, id) {
      this.mename = "";
      this.mename = name;
      this.parmaid = id;
      this.activeclass = id;
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    changetype() {
      this.mename = "";
      if (this.parmaid == "1") {
        this.mename = this.$t("opname.mename1");
        this.activeName = "1";
        this.changemenu(this.mename, this.parmaid);
      } else if (this.parmaid == "2") {
        this.mename = this.$t("opname.mename2");
        this.activeName = "2";
        this.changemenu(this.mename, this.parmaid);
      } else if (this.parmaid == "3") {
        this.mename = this.$t("opname.mename3");
        this.activeName = "2";
        this.changemenu(this.mename, this.parmaid);
      } else if (this.parmaid == "4") {
        this.mename = this.$t("opname.mename4");
        this.activeName = "2";
        this.changemenu(this.mename, this.parmaid);
      } else if (this.parmaid == "5") {
        this.mename = this.$t("opname.mename5");
        this.activeName = "2";
        this.changemenu(this.mename, this.parmaid);
      } else if (this.parmaid == "6") {
        this.mename = this.$t("opname.mename6");
        this.activeName = "5";
        this.changemenu(this.mename, this.parmaid);
      } else if (this.parmaid == "7") {
        this.mename = this.$t("opname.mename7");
        this.activeName = "3";
        this.changemenu(this.mename, this.parmaid);
      } else if (this.parmaid == "8") {
        // CNT List
        this.mename = this.$t("opname.mename8");
        this.activeName = "4";
        this.changemenu(this.mename, this.parmaid);
      }else if (this.parmaid == "9") {
        // CNT List
        this.mename = this.$t("opname.mename9");
        this.activeName = "4";
        this.changemenu(this.mename, this.parmaid);
      }else if (this.parmaid == "10") {
        // CNT List
        this.mename = this.$t("opname.mename10");
        this.activeName = "4";
        this.changemenu(this.mename, this.parmaid);
      }else if (this.parmaid == "11") {
        // CNT List
        this.mename = this.$t("opname.mename11");
        this.activeName = "4";
        this.changemenu(this.mename, this.parmaid);
      }
    },
    selectCntItem(item) {
      this.cntItem = item;
      this.getReportList({ ccerAssetId: item.id });
      this.cntListShow = false;
      this.cntDetailShow = true;
    },
    backCntList() {
      this.cntListShow = true;
      this.cntDetailShow = false;
    },
    openUrl(urlKey) {
      if(urlKey == 'reportURI'){
        if(this.token){
          let url = this.cntItem[urlKey];
          window.open(url, "ccer")
        }else{
          this.gotoLoginPage()
        }
      }else{
        let url = this.cntItem[urlKey];
        window.open(url, "ccer")
      }
      
      
    },
    gotoLoginPage(){
      authority.seturl(this.$route.fullPath)
      authority.getOauthLoginUrl(response =>{
        window.location = response.loginUrl
      })
    },
    openReportUrl(reportUrl) {
      window.open(reportUrl, "cnt report")
    },
    formatDate: function (dataVal) {
      if (null == dataVal) {
        return "";
      }
      return formatDate(dataVal);
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getCntList();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // authority.clearToken()
    this.token = authority.getToken()
    this.parmaid = this.$route.query.id;
    this.$bus.$on("changeid", (id) => {
      this.parmaid = id;
      this.changetype();
    });
    this.changetype();
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        window.fullWidth = document.documentElement.clientWidth;
        this.windowHeight = window.fullHeight; // 高
        this.windowWidth = window.fullWidth; // 宽
      })();
    };
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
.new_box {
  height: 420px;
  background: url("../../assets/img/btcbj.png") no-repeat;
  background-size: cover;
  font-size: 16px;
  color: #7d91aa;
}

.el-button {
  color: #218cba !important;
}

::v-deep .el-breadcrumb__inner {
  color: #c8c8c8 !important;
  font-size: 16px !important;
}
.sp {
  padding-top: 90px;
  padding-bottom: 90px;
  .el-row {
    margin-top: 10%;
  }
  .col_list {
    padding: 10px;
    margin-bottom: 20px;
  }
}
.showtitle {
  color: #fff !important;
  font-size: 40px;
  line-height: 50px;
}
.cmd-line {
  margin-top: 10px;
  margin-bottom: 10px;
}

.cmd-line button {
  padding-left: 30px;
  padding-right: 30px;
}
.span_box {
  font-weight: bold;
  color: #000;
}

.content {
  margin-top: -35px;
  min-height: 700px;

  .cont_box {
    padding: 20px;
    .el-row {
      margin-top: -20px;
    }
  }
  .h5 {
    font-size: 19px;
    font-family: inherit;
  }
  h6 {
    font-size: 14px;
    margin-bottom: 25px;
    font-weight: normal;
  }
  p {
    margin-top: 0;
    margin-bottom: 16px;
    font-size: 16px;
    line-height: 26px;
    font-family: ArialMT;
  }
  .new_box_list {
    padding-top: 10px;
    padding-bottom: 20px;
  }
}

.el-col-box {
  border: 0.1px solid #fff;
  border-radius: 5px;
  margin-right: 30px;
  box-shadow: 0px 5px 15px rgba(136, 136, 136, 0.2);
}
::v-deep .el-collapse-item__header {
  padding-left: 30px;
  font-weight: 700;
  font-size: 14px;
  color: #21212a;
  transition: all 0.4s ease;
  -webkit-transition: all 0.4s ease;
}
::v-deep .el-collapse-item__header:focus,
.el-collapse,
.el-col-box {
  border: none !important;
}
::v-deep .el-collapse-item__content {
  padding-left: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  background: #edeef3;
  .el-link {
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: normal;
    line-height: 35px;
    transition: all 0.25s ease;
    -webkit-transition: all 0.25s ease;
    color: #5d5d5d;
    display: block;
  }
  .el-link:hover {
    color: #218cba !important;
  }
  .active {
    color: #218cba !important;
  }
}
::v-deep .activeheader {
  .el-collapse-item__header {
    background: #218cba;
    color: #fff;
  }
}
.cont_box_col {
  transition: all 0.4s ease;
  -webkit-transition: all 0.4s ease;
  padding: 30px 20px 20px 20px;
  h3 {
    color: #218cba !important;
    margin: 28px 0;
    font-size: 32px;
    line-height: 42px;
    letter-spacing: 2px;
    font-family: Arial-BoldMT, Arial;
    padding: 10px 0 10px 0;
    font-weight: normal;
  }
  .h5 {
    color: #21212a !important;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 1px;
    padding-top: 10px;
    padding-bottom: 10px;
    font-weight: 800;
  }
  .h4 {
    font-weight: 800;
    font-family: "Roboto", sans-serif;
    font-size: 18px;
    line-height: 28px;
  }
}
.icon_box {
  padding: 30px 30px 30px 10px;
  p {
    padding-top: 10px;
    padding-left: 20px;
  }
}
.li_box {
  display: flex;
  i:after {
    content: url(../../assets/img/i1.png);
    margin-right: 9px;
  }
}
@media screen and (min-width: 280px) and (max-width: 1023px) {
  /deep/.el-collapse-item__header {
    font-size: 24px !important;
    height: 80px;
  }
  /deep/.el-collapse-item__content .el-link {
    font-size: 24px !important;
    line-height: 60px;
  }
  /deep/.el-collapse-item__content p {
    font-size: 24px !important;
    line-height: 60px;
  }
}
</style>
